import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles, CircularProgress /* , Tooltip */ } from '@material-ui/core'
import { DragIndicator } from '@material-ui/icons'
import { DragSource } from 'react-dnd'
import classNames from 'classnames'
import entityTypeIconMap from 'utils/entityTypeIconMap'
import language from 'utils/vast-languagepack'
import {
  addOrEditEventGoal,
	addEventGoalToCampaign,
} from 'actions/campaign/addOrEdit'
import currentNumberOfAllowedEventGoals from 'utils/currentNumberOfAllowedEventGoals'

const EventGoal = DragSource(
	(props) => props.type,
	{
		beginDrag: (props) => {
			console.log('beginDrag eventgoaloption')
			return { eventgoaloption: props.eventgoaloption }
		},
	},
	(connect, monitor) => ({
		connectDragSource: connect.dragSource(),
		connectDragPreview: connect.dragPreview(),
		isDragging: monitor.isDragging(),
	}),
)(
	({
		disabled,
		classes,
		eventgoaloption,
		funnelStageExpanded,
		Icon,
    addOrEditEventGoal,
		addEventGoalToCampaign,
		connectDragSource,
		isDropped,
		isDragging,
		connectDragPreview,
	}) =>
		connectDragSource(
			<span
				style={{
					opacity: isDragging ? 0.4 : 1,
					borderRadius: 35,
					transform: 'translate(0, 0)',
				}}
				className={disabled ? classes.eventDisabled : classes.event}
			>
				<span
					onClick={() => {
						if (!disabled) {
							eventgoaloption.entity_id_type &&
              eventgoaloption.entity_id_type !== '"-1"'
                ? addOrEditEventGoal({
										stage: funnelStageExpanded,
										...eventgoaloption,
								  })
								: addEventGoalToCampaign({
										event_goal: {
											id: eventgoaloption.id,
											event_type: eventgoaloption.event_type,
											entity: '0',
										},
										index: funnelStageExpanded,
								  })
						}
					}}
				>
					<Icon className={classes.eventIcon} />
					{eventgoaloption.short_description}
					<DragIndicator
						className={classNames(classes.eventIcon, classes.dragIcon)}
					/>
				</span>
			</span>,
		),
)

export default connect(
	(state) => ({
		eventgoaloptions: state.data.eventgoaloption,
		funnelCalendarView: state.campaign.addOrEdit.funnelCalendarView,
		funnelStageExpanded: state.campaign.addOrEdit.funnelStageExpanded,
		stagesLength: state.campaign.addOrEdit.campaign.stages.length,
		status: state.campaign.addOrEdit.campaign.status,
	}),
	(dispatch) =>
		bindActionCreators(
      { addOrEditEventGoal, addEventGoalToCampaign },
			dispatch,
		),
)(
	withStyles((theme) => ({
		text: {
			color: theme.palette.secondary.main,
			marginBottom: 10,
			fontSize: 13,
		},
		event: {
			cursor: 'grab',
			padding: '10px 0px 12px 10px',
			fontSize: 13,
			color: '#477848',
			backgroundColor: '#e1ebb1',
			border: '2px solid #477848',
			borderRadius: 35,
			display: 'inline-block',
			margin: 5,
			'&:hover': {
				backgroundColor: '#bcca7a',
			},
		},
		eventDisabled: {
			cursor: 'default',
			backgroundColor: '#faffe2',
			color: '#787878',
			border: '2px solid #787878',
			padding: '10px 0px 12px 10px',
			fontSize: 13,
			borderRadius: 35,
			display: 'inline-block',
			margin: 5,
		},
		eventIcon: {
			marginRight: 5,
			marginBottom: '-7px',
			fontSize: 22,
		},
		dragIcon: {
			fill: '#94b27c',
			cursor: 'grab',
		},
		dragIconDisabled: {
			cursor: 'default',
		},
	}))(
		({
			classes,
			eventgoaloptions,
			funnelCalendarView,
			funnelStageExpanded,
      addOrEditEventGoal,
			addEventGoalToCampaign,
			stagesLength,
			status,
		}) => {
			const disabled =
				funnelCalendarView !== 'funnel' ||
				!stagesLength ||
				status === 'L' ||
				status === 'C'

			return (
				<div>
					<div className={classes.text}>
						{language.campaign.add.eventGoalPaper.eventGoalDescription}{' '}
						<strong>
							{language.campaign.add.eventGoalPaper.eventGoalDescription2}
						</strong>{' '}
						{language.campaign.add.eventGoalPaper.eventGoalDescription3}{' '}
						<strong>
							{language.campaign.add.eventGoalPaper.eventGoalDescription4}
						</strong>{' '}
						{language.campaign.add.eventGoalPaper.eventGoalDescription5}{' '}
						<strong>
							{language.campaign.add.eventGoalPaper.eventGoalDescription6}
						</strong>{' '}
						{language.campaign.add.eventGoalPaper.eventGoalDescription7}
					</div>
					<div style={{ marginLeft: '-5px' }}>
						{eventgoaloptions ? (
							Object.values(eventgoaloptions)
								.filter((option) => parseInt(option.id) <= currentNumberOfAllowedEventGoals)
								.map((eventgoaloption) => {
									const Icon = entityTypeIconMap(
										'eventgoaloptions',
										eventgoaloption.id,
									)

									return (
										<EventGoal
											type="eventgoaloption"
											key={`taskPageEventGoal${eventgoaloption.id}`}
											Icon={Icon}
											disabled={disabled}
											eventgoaloption={eventgoaloption}
											funnelStageExpanded={funnelStageExpanded}
											classes={classes}
                      addOrEditEventGoal={addOrEditEventGoal}
											addEventGoalToCampaign={addEventGoalToCampaign}
										/>
									)
								})
						) : (
							<CircularProgress />
						)}
					</div>
				</div>
			)
		},
	),
)
